import types from "rdx/modules/adminDashboard/types";
import createAction from "rdx/utils/createAction";

export default {
  getAdminDashboardDetails: (payload) => createAction(types.GET_ADMIN_DASHBOARD_DETAILS_REQUEST, payload),

  setAdminDashboardDetails: (payload) => createAction(types.SET_ADMIN_DASHBOARD_DETAILS, payload),
  // INSERTION_PT (for script, do not remove)
};
